// @ts-nocheck
import {
  buildColumnMap,
  buildNormalizedAliases,
  buildStandardRecord,
  cleanText,
  guessPharmaceuticalCompanyName,
  normalizeHeader,
  shouldSkipRecord,
} from './settlementTemplateHelpers.js';

const AHNKOOK_FIELD_ALIASES = {
  hospitalName: ['처방처명'],
  drugName: ['품목명'],
  unitPrice: ['단가'],
  quantity: ['승인수량'],
  prescriptionAmount: ['합계금액'],
  feeRate: ['수수료율'],
  settlementAmount: ['지급수수료'],
  lowAmountFlag: ['10만원 미만 처'],
};

const REQUIRED_HEADERS = [
  '년월',
  '법인명',
  '처방처코드',
  '처방처명',
  'EDI처방월',
  '품목코드',
  '품목명',
  '단가',
  '승인수량',
  '합계금액',
  '수수료율',
  '공급가액',
  '부가세',
  '지급수수료',
  '10만원 미만 처',
];

const TARGET_SHEET_NAME = '지급수수료';

function isAhnkookProfile(profile) {
  return (
    normalizeHeader(profile.sheetName) === normalizeHeader(TARGET_SHEET_NAME) &&
    REQUIRED_HEADERS.every((header) =>
      profile.headers.some(
        (candidate) => normalizeHeader(candidate) === normalizeHeader(header),
      ),
    )
  );
}

const ahnkookPharmTemplate = {
  id: 'ahnkook-pharm',
  name: '안국약품 템플릿',
  match(context) {
    return context.headerProfiles.some(isAhnkookProfile);
  },
  extract(context) {
    const targetProfile = context.headerProfiles.find(isAhnkookProfile);
    if (!targetProfile) {
      return {
        rows: [],
        pharmaceuticalCompanyName: guessPharmaceuticalCompanyName(
          context.file.name,
        ),
        templateName: this.name,
      };
    }

    const sheetName = targetProfile.sheetName;
    const rows = context.sheetRowsMap[sheetName] || [];
    const headerRow = rows[targetProfile.headerRowIndex] || [];
    const columnMap = buildColumnMap(
      headerRow,
      buildNormalizedAliases(AHNKOOK_FIELD_ALIASES),
    );
    const extractedRows = [];

    rows.slice(targetProfile.headerRowIndex + 1).forEach((row, rowOffset) => {
      if (!Array.isArray(row) || row.every((cell) => cleanText(cell) === '')) {
        return;
      }

      const drugName = cleanText(row[columnMap.drugName]);
      if (!drugName) {
        return;
      }

      const note = cleanText(row[columnMap.lowAmountFlag])
        ? '10만원 미만 처'
        : '';

      const record = buildStandardRecord({
        fileName: context.file.name,
        sheetName,
        rowIndex: targetProfile.headerRowIndex + rowOffset + 1,
        templateId: this.id,
        detectedPharmaceuticalCompany: '안국약품',
        customerName: row[columnMap.hospitalName],
        drugName,
        unitPriceValue: row[columnMap.unitPrice],
        quantityValue: row[columnMap.quantity],
        prescriptionAmountValue: row[columnMap.prescriptionAmount],
        feeRateValue: row[columnMap.feeRate],
        settlementAmountValue: row[columnMap.settlementAmount],
        note,
      });

      if (shouldSkipRecord(record, row)) {
        return;
      }

      extractedRows.push(record);
    });

    return {
      rows: extractedRows,
      pharmaceuticalCompanyName: '안국약품',
      templateName: this.name,
    };
  },
};

export default ahnkookPharmTemplate;
